module.exports = __webpack_public_path__ + "assets/images/bell.ea536d9c151ca1238c5aeabc878a7966.svg";